/**
 * Coarse, account-wide permissions.
 *
 * Household roles ('owner' | 'editor' | 'viewer') answer "what may this person do inside
 * that household"; these answer "what may this person do to the service". They live in the
 * `permissions` column on `user`, which Better Auth surfaces as a `string[]` on the session.
 */

export const ADMIN_PERMISSION = 'admin';

export function hasPermission(
  permissions: readonly string[] | null | undefined,
  name: string,
): boolean {
  return permissions != null && permissions.includes(name);
}

/** True when the user may reach the admin section. Presentation only — the API re-checks. */
export function isAdmin(
  user: { permissions?: readonly string[] | null } | null | undefined,
): boolean {
  return hasPermission(user?.permissions, ADMIN_PERMISSION);
}
